export const paths = {
  index: '/',
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    emailSent: '/auth/email-sent',
    verify: '/auth/verify',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },
  dashboard: {
    index: '/dashboard',
    account: '/dashboard/account',
    analytics: {
      index: '/dashboard/analytics',
      seace: '/dashboard/analytics/seace',
      mivivienda: '/dashboard/analytics/mivivienda',
    },
    operaciones: {
      index: '/dashboard/operaciones',
      tablero: '/dashboard/operaciones/tablero',
      inversionistas: '/dashboard/operaciones/inversionistas',
      pymes: '/dashboard/operaciones/pymes',
      honorarios: '/dashboard/operaciones/honorarios',
      cierre: '/dashboard/operaciones/cierre',
      archivos: '/dashboard/operaciones/archivos',
      cronograma: '/dashboard/operaciones/cronograma',
      comunicaciones: '/dashboard/operaciones/comunicaciones',
      estructuracion: '/dashboard/operaciones/estructuracion',
      llamadoCapital: '/dashboard/operaciones/llamado-capital',
      seguimiento: '/dashboard/operaciones/seguimiento',
      fiduciaria: '/dashboard/operaciones/fiduciaria',
      tiposInversion: '/dashboard/operaciones/tipos-inversion',
      configuracion: '/dashboard/operaciones/configuracion',
      alimentar: '/dashboard/operaciones/alimentar',
    },
    users: '/dashboard/users',
    inversionista: {
      index: '/dashboard/inversionista',
      dashboard: '/dashboard/inversionista/dashboard',
      oportunidades: '/dashboard/inversionista/oportunidades',
      misInversiones: '/dashboard/inversionista/mis-inversiones',
      historial: '/dashboard/inversionista/historial',
      estadoCuenta: '/dashboard/inversionista/estado-cuenta',
      archivos: '/dashboard/inversionista/archivos',
    },
    pyme: {
      index: '/dashboard/pyme',
      dashboard: '/dashboard/pyme/dashboard',
      solicitar: '/dashboard/pyme/solicitar',
      cotizador: '/dashboard/pyme/cotizador',
      cronograma: '/dashboard/pyme/cronograma',
      facturacion: '/dashboard/pyme/facturacion',
      contrato: '/dashboard/pyme/contrato',
      alertas: '/dashboard/pyme/alertas',
      honorarios: '/dashboard/pyme/honorarios',
      cierre: '/dashboard/pyme/cierre',
      archivos: '/dashboard/pyme/archivos',
    },
    admin: '/dashboard/admin',
  },
  components: {
    index: '/components',
    dataDisplay: {
      detailLists: '/components/data-display/detail-lists',
      tables: '/components/data-display/tables',
      quickStats: '/components/data-display/quick-stats',
    },
    lists: {
      groupedLists: '/components/lists/grouped-lists',
      gridLists: '/components/lists/grid-lists',
    },
    forms: '/components/forms',
    modals: '/components/modals',
    charts: '/components/charts',
    buttons: '/components/buttons',
    typography: '/components/typography',
    colors: '/components/colors',
    inputs: '/components/inputs',
  },
  docs: 'https://material-kit-pro-react-docs.devias.io',
  notAuthorized: '/401',
  notFound: '/404',
  serverError: '/500',
};
